import React, { useEffect } from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import cibdPdfLogo from "./../../../../assets/images/cibdPdf.png";
import source1 from "./../../../../assets/fonts/OpenSansRegular.ttf";
import source2 from "./../../../../assets/fonts/OpenSansBold.ttf";
import source3 from "./../../../../assets/fonts/OpenSansSemiBold.ttf";

// Register font
Font.register({
  family: "OpenSans",
  fonts: [
    { src: source1, fontStyle: "normal", fontWeight: "normal" },
    { src: source2, fontStyle: "bold", fontWeight: "bold" },
    { src: source3, fontStyle: 600, fontWeight: 600 },
  ],
});

// Create styles
const styles = StyleSheet.create({
  page: {
    fontFamily: "OpenSans",
    fontWeight: "bold",
    backgroundColor: "#fff",
    paddingLeft: 50,
    paddingRight: 50,
  },
  Main: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  section: {
    // margin: 10,
    // padding: 10,
    paddingTop: 10,
    paddingBottom: 10,
    // flexGrow: 1,
  },
  section2: {
    // margin: 10,
    marginTop: 50,
    // padding: 10,
    paddingTop: 10,
    paddingBottom: 10,
    // flexGrow: 1,
  },

  test: {
    borderBottomColorColor: "#000",
    borderBottomWidth: 1,
    backgroundColor: "#DCE6F1",
    padding: 10,
  },
  image: {
    width: 200,
    padding: 10,
  },
  bill: {
    width: 250,
    borderColor: "#000",
    borderWidth: 1,
  },
  text: {
    fontSize: 8,
    color: "#3b61ad",
    padding: 2,
    fontWeight: "bold",
  },
  textBill1: {
    fontSize: 8,
    color: "#000",
    padding: 2,
    fontWeight: "bold",
  },
  textBill2: {
    fontSize: 8,
    color: "#000",
    padding: 2,
    paddingTop: 6,
    paddingBottom: 6,
    fontWeight: "bold",
  },
  invoice: {
    width: 170,
    borderColor: "#000",
    borderWidth: 1,
    textAlign: "center",
    // marginBottom: 10
  },
  invoice2: {
    width: 170,
    // borderColor: "#000",
    // borderWidth: 1,
    textAlign: "center",
    // marginBottom: 10
  },
  invoiceBottom: {
    width: 170,
    borderColor: "#000",
    borderWidth: 1,
    // borderTopWidth: 0,
    textAlign: "center",
    // marginBottom: 10
  },
  heading: {
    borderBottomColor: "#000",
    borderBottomWidth: 1,
    backgroundColor: "#DCE6F1",
    padding: 4,
    fontSize: 13,
    fontWeight: "bold",
  },
  head1: {
    fontSize: 8,
    backgroundColor: "#DCE6F1",
    borderBottomColor: "#000",
    borderBottomWidth: 1,
    borderRightColor: "#000",
    borderRightWidth: 1,
    width: "50%",
    padding: 2,
    fontWeight: "bold",
  },
  head2: {
    fontSize: 8,
    backgroundColor: "#DCE6F1",
    borderBottomColor: "#000",
    borderBottomWidth: 1,
    borderRightColor: "#000",
    borderRightWidth: 0,
    width: "50%",
    padding: 2,
    fontWeight: "bold",
  },
  head3: {
    fontSize: 8,
    borderRightColor: "#000",
    borderRightWidth: 1,
    width: "50%",
    padding: 2,
    fontWeight: "bold",
    borderBottomColor: "#000",
    borderBottomWidth: 0,
  },
  head4: {
    fontSize: 8,
    borderRightColor: "#000",
    borderRightWidth: 0,
    width: "50%",
    padding: 2,
    fontWeight: "bold",
    borderBottomColor: "#000",
    borderBottomWidth: 0,
  },
  head5: {
    // fontSize: 8,
    height:12,
    borderRightColor:"#fff",
    borderLeftColor:"#fff",
    borderRightWidth: 1,
    borderLeftWidth: 1,
    // width: "100%",
  },
  head6: {
    fontSize: 8,
    borderRightColor: "#000",
    borderRightWidth: 1,
    borderLeftColor:"#000",
    borderLeftWidth: 1,
    width: "50%",
    padding: 2,
    fontWeight: "bold",
    borderBottomColor: "#000",
    borderBottomWidth: 0,
  },
  head7: {
    fontSize: 8,
    borderRightColor: "#000",
    borderRightWidth: 1,
    width: "50%",
    padding: 2,
    fontWeight: "bold",
    borderBottomColor: "#000",
    borderBottomWidth: 0,
  },

  invtbl: {
    flexDirection: "row",
  },
  attn: {
    fontSize: 9,
    borderBottomColor: "#000",
    borderBottomWidth: 1,
    padding: 2,
    backgroundColor: "#EBF0DE",
    textAlign: "left",
  },
  attn2: {
    fontSize: 7,
    padding: 2,
    backgroundColor: "#EBF0DE",
    textAlign: "left",
  },
  invtbl2: {
    minHeight: 450,
    width: 495,
    // margin: 10,
    borderColor: "#000",
    borderWidth: 1,
  },
  invtblhead: {
    textAlign: "center",
    // height: 40,
    flexDirection: "row",
    borderColor: "#000",
    borderWidth: 0,
  },
  bottomTableHeading: {
    fontSize: 8,
    backgroundColor: "#DCE6F1",
    borderBottomColor: "#000",
    borderBottomWidth: 1,
    borderRightColor: "#000",
    borderRightWidth: 1,
    width: "20%",
    padding: 3,
    fontFamily: "OpenSans",
    fontWeight: "bold",
  },
  col2: {
    fontSize: 8,
    backgroundColor: "#DCE6F1",
    borderBottomColor: "#000",
    borderBottomWidth: 1,
    borderRightColor: "#000",
    borderRightWidth: 1,
    width: "40%",
    padding: 3,
    fontWeight: "bold",
  },
  col3: {
    fontSize: 8,
    backgroundColor: "#DCE6F1",
    borderBottomColor: "#000",
    borderBottomWidth: 1,
    borderRightColor: "#000",
    borderRightWidth: 1,
    width: "20%",
    padding: 3,
    fontWeight: "bold",
  },
  col4: {
    fontSize: 8,
    backgroundColor: "#DCE6F1",
    borderBottomColor: "#000",
    borderBottomWidth: 1,
    borderRightColor: "#000",
    borderRightWidth: 0,
    width: "20%",
    padding: 3,
    fontWeight: "bold",
  },
  invtblcol: {
    textAlign: "center",
    minHeight: 433,
    flexDirection: "row",
  },
  col5: {
    fontSize: 8,
    borderBottomColor: "#000",
    borderBottomWidth: 0,
    borderRightColor: "#000",
    borderRightWidth: 1,
    width: "20%",
    padding: 10,
    paddingLeft: 3,
    paddingRight: 3,
    fontWeight: "bold",
    textAlign: "left",
  },
  under:{
    // textDecoration: "underline",
    marginTop:15
  },
  col6: {
    fontSize: 8,
    borderBottomColor: "#000",
    borderBottomWidth: 0,
    borderRightColor: "#000",
    borderRightWidth: 1,
    width: "40%",
    padding: 10,
    paddingLeft: 3,
    paddingRight: 3,
    fontWeight: "bold",
    textAlign: "left",
  },
  col7: {
    fontSize: 8,
    borderBottomColor: "#000",
    borderBottomWidth: 0,
    borderRightColor: "#000",
    borderRightWidth: 1,
    width: "20%",
    padding: 10,
    paddingLeft: 3,
    paddingRight: 3,
    textAlign: "right",
  },
  unitPrice: {
    marginTop:25
  },
  col11: {
    fontSize: 8,
    borderBottomColor: "#000",
    borderBottomWidth: 0,
    borderRightColor: "#000",
    borderRightWidth: 1,
    width: "20%",
    padding: 10,
    paddingLeft: 3,
    paddingRight: 3,
    textAlign: "right",
    marginTop:25
  },
  col8: {
    fontSize: 8,
    borderBottomColor: "#000",
    borderBottomWidth: 0,
    width: "20%",
    padding: 10,
    paddingLeft: 3,
    paddingRight: 3,
    textAlign: "right",
  },
  col10 : {
    fontSize: 8,
    borderBottomColor: "#000",
    borderBottomWidth: 0,
    width: "20%",
    padding: 10,
    paddingLeft: 3,
    paddingRight: 3,
    textAlign: "right",
    marginTop:25,
    alignSelf:"flex-end",
    marginRight:35
  },
  
  col12 : {
    fontSize: 8,
    borderBottomColor: "#000",
    borderBottomWidth: 0,
    width: "20%",
    padding: 10,
    paddingLeft: 3,
    paddingRight: 3,
    textAlign: "right",
    marginTop:0,
    alignSelf:"flex-end",
    marginRight:35
  },
  footer: {
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    display: "flex",
  },
  footer1: {
    paddingTop: 10,
    paddingBottom: 8,
  },
  footertext: {
    fontSize: 8,
    color: "#000",
    // padding: 5,
    paddingTop: 2,
    paddingBottom: 2,
    fontWeight: "bold",
  },
  footer2: {
    // height: 100,
    // marginTop: -10,
    textAlign: "center",
  },
  ftxt: {
    borderColor: "#000",
    borderBottomColor: "#000",
    borderRightColor: "#000",
    borderRightWidth: 0,
    borderLeftWidth: 1,
    borderLeftColor: "#000",
    borderBottomWidth: 1,
    width: 180,
    paddingTop: 2,
    paddingBottom: 2,
    fontSize: 8,
    textAlign: "right",
    fontWeight: 400,
  },
  ftxt1: {
    borderColor: "#000",
    borderBottomColor: "#000",
    borderRightColor: "#000",
    borderRightWidth: 1,
    borderLeftWidth: 1,
    borderLeftColor: "#000",
    borderBottomWidth: 1,
    width: 101,
    paddingTop: 2,
    paddingBo5tom: 2,
    fontSize: 8,
    textAlign: "right",
    fontWeight: 400,
  },
  fBalanceTxt: {
    borderColor: "#000",
    borderBottomColor: "#000",
    borderRightColor: "#000",
    borderRightWidth: 0,
    borderLeftWidth: 1,
    borderLeftColor: "#000",
    borderBottomWidth: 1,
    width: 180,
    paddingTop: 8,
    paddingBottom: 8,
    fontSize: 8,
    fontFamily: "OpenSans",
    fontWeight: "bold",
    textAlign: "right",
  },
  fBalanceTxt1: {
    borderColor: "#000",
    borderBottomColor: "#000",
    borderRightColor: "#000",
    borderRightWidth: 1,
    borderLeftWidth: 1,
    borderLeftColor: "#000",
    borderBottomWidth: 1,
    width: 101,
    paddingTop: 8,
    paddingBottom: 8,
    fontSize: 8,
    fontFamily: "OpenSans",
    fontWeight: "bold",
    textAlign: "right",
  },
});

// Create Document Component
const PdfGenerator = (props) => {

  useEffect(()=>{
    console.log(props.data)
  })
  return (
  <Document>
    <Page size="A4" style={styles.page}>
      <View style={styles.Main}>
        <View style={styles.section}>
          <View>
            <Image
              source={require("./../../../../assets/images/cibdPdf.png")}
              style={styles.image}
            />
          </View>
          <View style={{ marginBottom: 10 }}>
            <Text style={styles.text}>{props.data.CustAddress}</Text>
            <Text style={styles.text}>{props.data.CustCity}, {props.data.CustState}, {props.data.CustZip}</Text>
            <Text style={styles.text}>
              {props.data.Phonenumber}
            </Text>
          </View>
          <View style={styles.bill}>
            <Text style={styles.heading}>Bill To</Text>
            <Text style={styles.textBill1}>{props.data.BillToName}</Text>
            <Text style={styles.textBill1}>{props.data.BillToNumber}</Text>
            <Text style={styles.textBill1}>{props.data.BillToAddress}</Text>
            <Text style={styles.textBill1}>{props.data.BillToCustCity}, {props.data.BillToCustState}, {props.data.BillToCustZip}</Text>
          </View>
        </View>
        <View style={styles.section2}>
          <View style={styles.invoice}>
            <Text style={styles.heading}>Invoice</Text>
            <View style={styles.invtbl}>
              <Text style={styles.head1}>Date</Text>
              <Text style={styles.head2}>Invoice #</Text>
            </View>
            <View style={styles.invtbl}>
              <Text style={styles.head3}>{props.data.ReportDate}</Text>
              <Text style={styles.head4}>{props.data.DebitMemoNum}</Text>
            </View>
            
            
          </View>
          <View style={styles.invoice2}>
          {
              props.data.TermsNet ? <View style={styles.invtbl}>
                  <Text style={styles.head6}>PMT {props.data.TermsNet}</Text>
                  <Text style={styles.head7}></Text>
                  </View>
                : <View style={styles.invtbl}>
                  <Text style={styles.head5}></Text>
                  </View>
            }
            </View>
          <View style={styles.invoiceBottom}>
            <Text style={styles.attn}>{props.data.AccountPayable}</Text>
            <Text style={styles.attn}>{props.data.ServiceFeeName}</Text>
            <Text style={styles.attn2}>
              {/* CIBD Distributors Account # 18122153 */}
              {props.data.DistributorName}  Account # {props.data.CIBDDistributorsAccount}
            </Text>
          </View>
        </View>
      </View>
      <View style={styles.invtbl2}>
        <View style={styles.invtblhead}>
          <Text style={styles.bottomTableHeading}>QUANTITY</Text>
          <Text style={styles.col2}>DESCRIPTION</Text>
          <Text style={styles.col3}>UNIT PRICE</Text>
          <Text style={styles.col4}>AMOUNT</Text>
        </View>
        <View style={styles.invtblcol}>
          <Text style={styles.col5}></Text>
          <View style={styles.col6}>
          <Text > {props.data.DESCRIPTION}</Text>
          <Text style={styles.under}>{props.data.FileText}</Text>
          <Text style={styles.under}>{props.data.AdminFees}</Text>
          </View>
          <View style={styles.col7}>
            {props.data.UNITPRICE !== 0 && props.data.UNITPRICE  ? <Text style={props.data.FileText ? styles.unitPrice: ''}> {props.data.UNITPRICE}</Text> :
            <Text style={props.data.FileText ? styles.unitPrice : '' }></Text>
            }
          </View>
          <View>
            <Text style={props.data.FileText ? styles.col10 : styles.col8 }> {props.data.FileText == "Chargebacks" && props.from ==='Octapharama' ? props.data.ChargebacksAmount : props.data.AMOUNT }</Text>
            <Text style={props.data.AdminFees ? styles.col12 : styles.col8 }>{props.data.AdminFees ? props.data.AdminFee : ''}</Text>
          </View>
          
        </View>
      </View>
      <View style={styles.footer}>
        <View style={styles.footer1}>
          <Text style={styles.footertext}>Please remit payments to: </Text>
          <Text style={styles.footertext}>CIBD Distributors </Text>
          <Text style={styles.footertext}>2670 N. Main Street, Suite 100</Text>
          <Text style={styles.footertext}>Santa Ana, CA 92705</Text>
          <Text style={styles.footertext}></Text>
          <Text style={styles.footertext}>
            If you have any questions concerning this invoice,
          </Text>
          <Text style={styles.footertext}>please call (714) 227-9689</Text>
        </View>
        <View style={styles.footer2}>
          <View style={styles.invtbl}>
            <Text style={styles.ftxt}> Total Amount Due &nbsp;&nbsp;</Text>
            <Text style={styles.ftxt1}> {props.data.AMOUNT} &nbsp;&nbsp;</Text>
          </View>
          <View style={styles.invtbl}>
            <Text style={styles.ftxt}> Payments/Credits &nbsp;&nbsp;</Text>
            <Text style={styles.ftxt1}> &nbsp;&nbsp;</Text>
          </View>
          <View style={styles.invtbl}>
            <Text style={styles.fBalanceTxt}> Balance Due &nbsp;&nbsp;</Text>
            <Text style={styles.fBalanceTxt1}> {props.data.AMOUNT} &nbsp;&nbsp;</Text>
          </View>
        </View>
      </View>
    </Page>
  </Document>
 )
  };

export default PdfGenerator;
